function footerNew() {
  const footerMenuMobile = document.querySelectorAll(
    ".footer-menu .footer-menu__heading-btn"
  );

  if (!footerMenuMobile.length) return;
  footerMenuMobile.forEach(menu => {
    menu.addEventListener("click", function() {
      menu.parentElement.classList.toggle("is-open");
    });
  });
}

document.addEventListener("DOMContentLoaded", function() {
  footerNew();
});
